<template>
  <div class="markDown">
      <div v-html="markHtml">

      </div>
      <!-- <t1></t1> -->
  </div>
</template>

<script>
 import showdown from 'showdown'
 import tr from './report.md'
 export default {
    components:{
        // t1
    },
    data () {
        return {
            markHtml:"",
        }
    },
    mounted () {
        let converter = new showdown.Converter();
        let text = tr.toString();
        this.markHtml = converter.makeHtml(text);
    }
}
</script>
<style>
    .markDown{
        height: 100%;
        width: 100%;
    }
</style>